import { makeCygnusApiCall } from "../../../../../api/api";

/**
 * Saves a new custom MDM field for Client Data Management or Engagement Letter usage.
 *
 * @param payload - The custom field data to be saved.
 * @returns A Promise resolving to the full API response object.
 */
export const saveCustomField = async (
  payload: {
    field_name: string;
    field_type: string;
    field_category: string;
    field_purpose: string[]; // e.g., ["CLIENT_ONBOARDING", "ENGAGEMENT_LETTER"]
    field_options?: { id: number; label: string; value: string }[]; // Only required for select, radio, or checkbox
  },
  setIsSaving: (arg: boolean) => void,
  onFieldCreated?: () => void
): Promise<{ success: boolean; data?: any; message?: string }> => {
  setIsSaving(true);
  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/onboarding/create_custom_field/",
    payload,
    show_message: true,
    customized_success_message: "Custom field added successfully.",
    customized_failure_message: "Failed to add custom field.",
    customized_error_message:
      "An error occurred while adding the custom field.",
    forMDM: true,
  });
  if (response.success) {
    setIsSaving(false);
    onFieldCreated?.();
  }
  return response;
};
